<section class="flex h-full flex-col overflow-hidden">
    <div class="flex flex-1 flex-col gap-6 overflow-y-auto">
        <!-- Schedule Toggle Header -->
        <section class="flex items-center justify-between rounded-xl border border-neutral-200 bg-white px-3 py-1">
            <p class="text-sm font-medium text-neutral-900">그룹 편성 스케줄 사용</p>
            <app-toggle [(value)]="scheduleEnabled" />
        </section>

        @if (scheduleEnabled()) {
            <section class="flex flex-col gap-5 rounded-xl border border-neutral-200 bg-white p-4">
                <!-- Repeat Mode Segmented Control -->
                <div class="flex flex-col gap-1">
                    <app-label size="sm">반복 모드</app-label>
                    <div class="grid grid-cols-2 gap-2">
                        <button
                            [ngClass]="
                                scheduleType() === 'day'
                                    ? 'bg-blue-600 border-blue-600 text-white'
                                    : 'border-neutral-200 text-neutral-900 hover:bg-neutral-50'
                            "
                            (click)="scheduleType.set('day')"
                            class="flex items-center justify-center border rounded-md px-4 py-2 text-center text-xs font-medium transition-colors"
                        >
                            요일 반복 (Weekly)
                        </button>
                        <button
                            [ngClass]="
                                scheduleType() === 'daterange'
                                    ? 'bg-blue-600 border-blue-600 text-white'
                                    : 'border-neutral-200 text-neutral-900 hover:bg-neutral-50'
                            "
                            (click)="scheduleType.set('daterange')"
                            class="flex items-center justify-center border rounded-md px-4 py-2 text-center text-xs font-medium transition-colors"
                        >
                            기간 지정 (Date)
                        </button>
                    </div>
                </div>

                <!-- Date Range Section -->
                @if (scheduleType() === 'daterange') {
                    <div class="flex flex-col gap-3">
                        <app-input-date-picker label="시작일" [(value)]="startDate" size="md" />
                        <app-input-date-picker label="종료일" [(value)]="endDate" size="md" />
                    </div>
                }

                <!-- Day Selection Section -->
                @if (scheduleType() === 'day') {
                    <div class="flex flex-wrap items-center gap-2">
                        @for (item of dayItems; track item.value) {
                            <button
                                [ngClass]="
                                    seletedDays().includes(item.value)
                                        ? 'bg-blue-600 text-white border-blue-600'
                                        : 'bg-white text-neutral-900 border-neutral-300 hover:bg-neutral-50'
                                "
                                (click)="seleteDay(item.value)"
                                class="flex h-10 w-10 items-center justify-center rounded-full border text-sm font-medium transition-colors"
                            >
                                {{ item.label }}
                            </button>
                        }
                    </div>
                }

                <!-- Time Limit Section -->
                <div class="flex flex-col gap-3 border-t border-neutral-200 pt-4">
                    <div class="flex items-center justify-between">
                        <app-label size="sm">시간 제한</app-label>
                        <app-toggle [(value)]="timeActive" />
                    </div>

                    @if (timeActive()) {
                        <div class="flex items-center gap-2">
                            <app-input-time [(value)]="startTime" class="flex-1"></app-input-time>
                            <p class="text-neutral-500">-</p>
                            <app-input-time [(value)]="endTime" class="flex-1"></app-input-time>
                        </div>
                    }
                </div>
            </section>
        }

        <div class="sticky bottom-0">
            <app-button (click)="submit()" color="primary" expand class="w-full shadow-sm"> 저장 </app-button>
        </div>
    </div>
</section>
